import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

// Default = dark "drafting table" mode. Light = "site plan" mode.
export function ThemeProvider({ children }) {
  const [light, setLight] = useState(() => localStorage.getItem("mre_theme") === "light");

  useEffect(() => {
    const root = document.documentElement;
    if (light) {
      root.classList.add("lightmode");
      localStorage.setItem("mre_theme", "light");
    } else {
      root.classList.remove("lightmode");
      localStorage.setItem("mre_theme", "dark");
    }
  }, [light]);

  return (
    <ThemeContext.Provider value={{ light, toggle: () => setLight((v) => !v) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handler = () => setReduced(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return reduced;
}
